// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3w5m3","list":"PatternAutocomplete_list__tNZVq"};